import { type ComponentPropsWithoutRef } from 'react';
export const QuizFullLogo = (props: Omit<ComponentPropsWithoutRef<'img'>, 'src' | 'alt'>) => {
  return <img src="/assets/ZEPQuiz-logo.svg" alt="logo" {...props} data-sentry-component="QuizFullLogo" data-sentry-source-file="QuizFullLogo.tsx" />;
};